/**
 * The old skill FX as a whole (the user, 2026-10-11: "why do I still see the OLD effects, the leaves?"): every effect a
 * move drew before the sample-style ports — the ink kind templates and their pixel parts (the giant sword, flying-sword
 * bursts), the C0-SKILLFX detail motifs (leaves, ring smears, auras, wakes; render/ink/detail), the Effects' shared
 * spectacle (gathering column and sigil, shock, crack, beam, speed lines, the shared slash) and each move's legacy
 * effect file (render/fx/<fx>.ts). While off a move with no port ON shows its motion only, and its blows the plain pixel
 * hit (render/ink/pixelHit.ts); a move with its port ON plays the port (render/fx/sampleArt/port.ts), as before.
 * `true` brings the old look back. Dev before/after captures: `window.__oldSkillFx = true | false` over it.
 */
export const OLD_SKILL_FX = false;

export const oldFxOn = (): boolean => {
  const o =
    import.meta.env?.DEV && typeof window !== 'undefined'
      ? (window as unknown as { __oldSkillFx?: boolean }).__oldSkillFx
      : undefined;
  return o ?? OLD_SKILL_FX;
};
